import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { MenuItem } from '../../models/menu-item';
import { Router } from '@angular/router';
import { AppRoutes } from '../../Constants/app-routes';

@Injectable()
export class MenuItemsService {

  private _menuItems: Array<MenuItem> = new Array();
  private _menuItemsStream: ReplaySubject<Array<MenuItem>> = new ReplaySubject(1);

  constructor(private router: Router) { 
    this._menuItems.push(
      new MenuItem('Ebook', 1, 'assets/imgs/Ebook.svg', () => {
        this.router.navigateByUrl(AppRoutes.bookshelf);
      }),
      new MenuItem('FAQ', 2, 'assets/images/FAQ.svg', () => {
        this.router.navigateByUrl(AppRoutes.faq);
      }),
      new MenuItem('Copyright and Licenses', 3, 'assets/images/CopyrightandLicensesIcon.svg', () => {
        this.router.navigateByUrl(AppRoutes.copyrightAndLicenses);
      }),
      new MenuItem('Privacy Policy', 3, 'assets/images/PrivacyPolicy.png', () => {
        this.router.navigateByUrl(AppRoutes.privacyPolicy); 
      })
    );
    this.pushMenuItems();
  }

  public getMenuItems(): Observable<Array<MenuItem>> {
    return this._menuItemsStream;
  }

  public addMenuItems(...menuItems: Array<MenuItem>) {
    menuItems.forEach(item => {
      let existingItem = this._menuItems.find((value) => {
        return item.description == value.description;
      });
      if (existingItem == null) {
        this._menuItems.push(item);
      }
    });
    this.pushMenuItems();
  }

  private pushMenuItems() {
    this.sortMenuItems();
    this._menuItemsStream.next(this._menuItems);
  }

  private sortMenuItems() {
    this._menuItems.sort((a, b) => {
      return a.order - b.order;
    });
  }
}
